import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="judge-mode-toggle"
export default class extends Controller {
  static targets = ["modeSelector", "nominationsSection", "primaryJudgeInfo", "sanitaryJudgeInfo"]

  connect() {
    // Инициализируем состояние при загрузке страницы
    this.updateSections()
  }

  toggleMode() {
    this.updateSections()
  }

  updateSections() {
    const selectedMode = this.getSelectedMode()
    
    if (selectedMode === "select_nominations") {
      this.showNominationsSection()
      this.hidePrimaryJudgeInfo()
      this.hideSanitaryJudgeInfo()
    } else if (selectedMode === "primary_judge") {
      this.hideNominationsSection()
      this.showPrimaryJudgeInfo()
      this.hideSanitaryJudgeInfo()
    } else if (selectedMode === "sanitary_judge") {
      this.hideNominationsSection()
      this.hidePrimaryJudgeInfo()
      this.showSanitaryJudgeInfo()
    }
  }

  getSelectedMode() {
    const checkedRadio = this.element.querySelector('input[name="judge_mode"]:checked')
    return checkedRadio ? checkedRadio.value : "select_nominations"
  }

  showNominationsSection() {
    if (this.hasNominationsSectionTarget) {
      this.nominationsSectionTarget.classList.remove("d-none")
    }
  }

  hideNominationsSection() {
    if (this.hasNominationsSectionTarget) {
      this.nominationsSectionTarget.classList.add("d-none")
    }
  }

  showPrimaryJudgeInfo() {
    if (this.hasPrimaryJudgeInfoTarget) {
      this.primaryJudgeInfoTarget.classList.remove("d-none")
    }
  }

  hidePrimaryJudgeInfo() {
    if (this.hasPrimaryJudgeInfoTarget) {
      this.primaryJudgeInfoTarget.classList.add("d-none")
    }
  }

  showSanitaryJudgeInfo() {
    if (this.hasSanitaryJudgeInfoTarget) {
      this.sanitaryJudgeInfoTarget.classList.remove("d-none")
    }
  }

  hideSanitaryJudgeInfo() {
    if (this.hasSanitaryJudgeInfoTarget) {
      this.sanitaryJudgeInfoTarget.classList.add("d-none")
    }
  }
}